/**
 * Change styles to owl slider container.
 */
 function owl_slider_container(){
    const elements = document.querySelectorAll(".owl-slider-container");  
    if (elements.length) {
        elements.forEach(function (element) { 
            $(element).owlCarousel({
                items: 1,
                itemsDesktop: false,
                itemsDesktopSmall: false,
                itemsTablet: false,
                itemsMobile: false,
                navigation: false,
                loop: true,
                autoplay: true,
                autoplaySpeed: 500,
                autoplayTimeout: 5000,
                autoplayHoverPause: true
            });
        });
    }
}

owl_slider_container();

export default owl_slider_container;